/**
 * Connected-integration helpers.
 *
 * `kestrel` and `approval` are built-in pseudo-integrations that always report
 * connected, so they are not evidence that a customer has onboarded anything.
 * Both the builder (deciding whether to offer simulated mode) and the Library
 * (deciding whether to offer simulated suggestions) need that distinction, so
 * the rule lives in one place.
 */

const ALWAYS_CONNECTED = new Set(['kestrel', 'approval']);

/** Minimal shape needed from the integrations-status payload. */
export interface IntegrationConnectionState {
  id: string;
  connected?: boolean;
}

/** IDs of integrations the customer has actually connected. */
export function realConnectedIntegrationIds(
  integrations: IntegrationConnectionState[] | null | undefined,
): string[] {
  return (integrations || [])
    .filter(i => i.connected && !ALWAYS_CONNECTED.has(i.id))
    .map(i => i.id);
}

/** Whether the customer has connected at least one real integration. */
export function hasRealIntegration(
  integrations: IntegrationConnectionState[] | null | undefined,
): boolean {
  return realConnectedIntegrationIds(integrations).length > 0;
}
